import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { TrainECPBModel, TrainEventRecordModel } from "../../../../shared/models/api/models";

export type TrainEventRecordState = {
    form: TrainEventRecordModel,
    originalForm: TrainEventRecordModel,
    formValidation: boolean[],
    checkValidation: boolean,
}

const emptyForm: TrainEventRecordModel = {
    id: -1
};

const createInitialState = (): TrainEventRecordState => ({
    form: Object.assign({}, emptyForm),
    originalForm: emptyForm,
    formValidation: [],
    checkValidation: false,
});


const trainEventRecordStateSubject = new BehaviorSubject<TrainEventRecordState>(createInitialState());

export const updateFormState = (form: TrainEventRecordModel) => {
    trainEventRecordState.setState(s => {
        s.form = form;
    });
}
const validate = (field: string, value: any) => {
    updateValidationState({ ...trainEventRecordStateSubject.value.formValidation, [field]: isValueInvalid(value) });
}

export const fieldInvalid = (field: string) => {
    if (!trainEventRecordStateSubject.value.checkValidation) {
        return false;
    }
    let value = Object(trainEventRecordStateSubject.value.formValidation)[field] as boolean;
    if (value === undefined) return true;
    return value;
}
const updateValidationState = (validation: boolean[]) => {
    trainEventRecordState.setState(s => {
        s.formValidation = validation;
    });
}

const isValueInvalid = (value: any) => {
    if (value === undefined) return true;
    if (typeof (value) === 'string' && !value.trim()) return true;
    return false;
}

export const handleDurationDelayChange = (field: string) => (event: any) => {
    let value = event;
    if (value.target?.value !== undefined) {
        value = value.target.value;
    }
    if (value.value !== undefined) {
        value = value.value;
    }

    // Allow only digits
    value = value.replace(/\D/g, "");

    // Maximum 4 digits
    value = value.substring(0, 4);

    // Format as HH:mm
    if (value.length > 2) {
        value = value.slice(0, 2) + ":" + value.slice(2);
    }
    updateFormState({ ...trainEventRecordStateSubject.value.form, [field]: value });
    validate(field, value ? value : undefined);

};

export const handleChange = (field: string) => (event: any) => {
    let value = event;
    if (value.target?.value !== undefined) {
        value = value.target.value;
    }
    if (value.value !== undefined) {
        value = value.value;
    }
    updateFormState({ ...trainEventRecordStateSubject.value.form, [field]: value });
    validate(field, value);
};

export const handleSingleCheckboxChange = (field: string) => (event: any) => {
    let value = event;
    if (value.target?.checked !== undefined) {
        value = value.target.checked;
    } else {
        value = false;
    }

    updateFormState({ ...trainEventRecordStateSubject.value.form, [field]: value });
    validate(field, value ? value : undefined);
}

export const handleMultipleCheckboxChange = (field: string) => (event: any) => {

    const checked = event.target.checked;
    const value = event.target.value;

    const currentValues =
        (trainEventRecordStateSubject.value.form as any)[field] || [];

    let updatedValues:string[] = [];

    if (checked) {
        updatedValues = [...currentValues, value];
    } else {
        updatedValues = currentValues.filter((x: string) => x !== value);
    }

    updateFormState({
        ...trainEventRecordStateSubject.value.form,
        [field]: updatedValues
    });

    validate(field, updatedValues);
}
export const enableValidation = () => {
    trainEventRecordState.setState(d => { d.checkValidation = true });
}
export const resetValidation = () => {
    trainEventRecordState.setState(d => { d.formValidation = [], d.checkValidation = false });
}

export const handlePressureChange = (index: number, field: keyof TrainECPBModel) => (event: any) => {
    let value = event;

    if (value.target?.value !== undefined) {
        value = value.target.value;
    }
    if (value.value !== undefined) {
        value = value.value;
    }
    const existingData = trainEventRecordStateSubject.value.form.TrainECPBModelList || [];
    const updateData = [...existingData];
    if (!updateData[index]) {
        updateData[index] = {};
    }
    updateData[index][field] = Number(value);
    updateFormState({ ...trainEventRecordStateSubject.value.form, TrainECPBModelList: updateData });
    validate(field, value);
};

export const trainEventRecordState = {
    subscribe: (setState: any) => trainEventRecordStateSubject.subscribe(setState),
    setState: (fn: (state: TrainEventRecordState) => void) => {
        var newState = Object.assign({}, trainEventRecordStateSubject.getValue());
        fn(newState);
        trainEventRecordStateSubject.next(newState);
    },
    reset: () => {
        trainEventRecordStateSubject.next(createInitialState())
    }
}